<form #savedSettingsForm="ngForm">
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
  </div>
  <div class="modal-body">

    @if(appSubscription.subscriptionLevel != 'Trial' && mode == SavedSettingsMode.save){
    <div class="form-group row mb-3">
      <div class="col">
        <label for="name" class="form-label">Name</label>
        <input type="text" class="form-control" id="savedSettingsName" name="name"
               [(ngModel)]="name"
               [required]="true" />
      </div>
    </div>
    }

    @if(appSubscription.subscriptionLevel != 'Trial' && mode == SavedSettingsMode.load && savedSettings?.totalCount > 0){
    <div class="scrollable-table mb-3">
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="sticky-top"></th>
            <th class="sticky-top">Name</th>
            <th class="d-none d-md-table-cell sticky-top">Manufacturer</th>
            <th class="sticky-top">Model</th>
            <th class="sticky-top"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let savedSetting of savedSettings.data" class="pointer"
              [ngClass]="{'table-active': selectedSavedSettings?.id == savedSetting.id}"
              (click)="selectSavedSettings(savedSetting)">
            <td><input type="checkbox" class="pe-none form-check-input" [checked]="selectedSavedSettings?.id == savedSetting.id" /></td>
            <td>{{savedSetting.name}}</td>
            <td class="d-none d-md-table-cell">{{savedSetting.vehicle.manufacturer}}</td>
            <td>{{savedSetting.vehicle.model}}</td>
            <td class="actions">
              <button type="button" class="btn btn-link p-0 text-danger" (click)="delete(savedSetting, $event)">
                <i class="fa-solid fa-trash-can"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ngb-pagination class="d-flex justify-content-center"
                    [collectionSize]="savedSettings.totalCount"
                    [(page)]="page"
                    [pageSize]="savedSettings.pageSize"
                    aria-label="Default pagination"
                    (pageChange)="search()">
    </ngb-pagination>
    }
    @else if(appSubscription.subscriptionLevel != 'Trial' && mode == SavedSettingsMode.load) {
    <p class="text-center">
      You have not saved any settings yet.
    </p>
    }

    @if (appSubscription.subscriptionLevel == 'Trial'){
      <p>
          The ability to save and load settings is only available for users with active subscriptions. Please consider
          purchasing a subscription to unlock all available features.
      </p>
    }
  </div>




  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="close()">Close</button>
    @if(appSubscription.subscriptionLevel != 'Trial' && mode == SavedSettingsMode.save){
    <button type="button" class="btn btn-primary"
            (click)="save()"
            [disabled]="savedSettingsForm.invalid">
      <i class="fa-solid fa-floppy-disk me-2"></i>Save
    </button>
    }

    @if(appSubscription.subscriptionLevel != 'Trial' && mode == SavedSettingsMode.load){
    <!--<button type="button" class="btn btn-danger"
          (click)="delete()"
          [disabled]="selectedSavedSettings == null">
    <i class="fa-solid fa-trash-can me-2"></i>delete
  </button>-->


    <button type="button" class="btn btn-primary"
            (click)="load()"
            [disabled]="selectedSavedSettings == null">
      <i class="fa-solid fa-file-arrow-down me-2"></i>Load
    </button>
    }
  </div>
</form>
